import React from "react";
import { Cards, PageTitle, Wrapper } from "./style";
import ContactCard from "../../components/contact/ContactCard";

type ContactType = {
  url: string;
  key:
    | "twitter"
    | "whatsapp"
    | "facebook"
    | "email"
    | "instagram"
    | "linkedin"
    | "website"
    | "support"
    | "youtube";
  title: string;
  subTitle: string;
};

const contacts: ContactType[] = [
  {
    key: "whatsapp",
    title: "Message on WhatsApp",
    subTitle: "+1 415-993-3858",
    url: "https://wa.me/+14159933858",
  },
  {
    key: "email",
    title: "Send us an email",
    subTitle: "support@klasha.com",
    url: "mailto:support@klasha.com",
  },
  {
    key: "website",
    title: "Visit our website",
    subTitle: "www.klasha.com",
    url: "https://www.klasha.com",
  },
  {
    key: "instagram",
    title: "Klasha on Instagram",
    subTitle: "@getklasha",
    url: "https://www.instagram.com/getklasha/",
  },

  {
    key: "twitter",
    title: "Klasha on X",
    subTitle: "@GetKlasha",
    url: "https://x.com/GetKlasha",
  },
  {
    key: "linkedin",
    title: "Klasha on Linkedin",
    subTitle: "Klasha",
    url: "https://www.linkedin.com/company/klasha/",
  },
];

const ContactUs = () => (
  <Wrapper>
    <PageTitle>Contact us</PageTitle>
    <Cards>
      {contacts.map((contact) => (
        <ContactCard
          url={contact.url}
          key={contact.key}
          id={contact.key}
          title={contact.title}
          subTitle={contact.subTitle}
        />
      ))}
    </Cards>
  </Wrapper>
);

export default ContactUs;
